import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleList from './components/ArticleList';
import HotComments from './components/HotComments';
import CTASection from './components/CTASection';
import { OrganizationSchema, WebSiteSchema, WebPageSchema, FAQPageSchema, homepageFaqs } from '@/components/feature/SchemaOrg';
import { siteInfo } from '@/mocks/site';

export default function Home() {
  const canonicalUrl = typeof window !== 'undefined' ? window.location.origin : '';

  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title={`${siteInfo.name} - 吃瓜群众免费吃瓜与在线爆料大全`}
        description={siteInfo.description}
        url={canonicalUrl}
      />
      <FAQPageSchema questions={homepageFaqs} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleList />
        <HotComments />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}